var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"more"},[_c('div',{staticClass:"more-span"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }